export default "__VITE_ASSET__P8Y8CD9n__"